export const NAME = 'agentReviewPage'

export const AGENT_FULL_NAME_DESCRIPTION = 'Agent Review on RentSpree'
export const STAR = '\u2605'
